import { Check } from "@phosphor-icons/react"
import { Icon } from "@tokenterminal/core/ui/icon/Icon"
import { Badge } from "@tokenterminal/core/ui/messaging/badge/Badge"
import { Fragment } from "react"
import MarketingHeading from "../../common/MarketingHeading"

interface CTATier {
  id: string
  title: string
  features: string[]
  cta: React.ReactNode
  badge?: { label: string; color: "green" | "blue" | "orange" | "red" }
}

interface ProductCTASectionProps {
  tiers: [CTATier, CTATier]
}

export function ProductCTASection({ tiers }: ProductCTASectionProps) {
  return (
    <div className="max-w-[900px] mx-auto mt-72 mb-24">
      <div className="flex items-stretch gap-12 flex-col md:flex-row">
        {tiers.map((tier, index) => (
          <Fragment key={tier.id}>
            <div className="flex-1">
              <div className="flex flex-col gap-5">
                <div className="flex items-center gap-2">
                  {tier.badge && (
                    <Badge
                      color={tier.badge.color}
                      variant="solid"
                      size="small"
                      className="shrink-0"
                    >
                      {tier.badge.label}
                    </Badge>
                  )}
                  <MarketingHeading level={2} className="text-2xl">
                    {tier.title}
                  </MarketingHeading>
                </div>
                <div className="flex flex-col gap-3">
                  {tier.features.map((feature) => (
                    <div key={feature} className="flex items-center justify-start gap-2">
                      <Icon as={Check} />
                      <div className="text-base text-fg-default">{feature}</div>
                    </div>
                  ))}
                </div>
                <div className="flex items-center justify-start gap-2">{tier.cta}</div>
              </div>
            </div>
            {index === 0 && (
              <div
                className="border-l border-border-default hidden md:block"
                style={{
                  width: "1px",
                }}
              />
            )}
          </Fragment>
        ))}
      </div>
    </div>
  )
}
